import Calendar from "./fullcalendar";
import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { decryptData } from "../../core/utils/encryptUtils";

function CustomCalendar() {
  const [showForm, setShowForm] = useState(false);
  const Legend = ({ color, label }: { color: string; label: string }) => (
    <div className="d-flex align-items-center gap-1">
      <span
        style={{
          width: "20px",
          height: "5px",
          backgroundColor: color,
          borderRadius: "2px",
          display: "inline-block",
        }}
      />
      <small>{label}</small>
    </div>
  );

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const sidebarWidth = 251;

  // Permission
  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];
  const canAdd = permissions.includes("Add") || permissions.includes("AllowAll");

  const calendarContainerStyle: React.CSSProperties = {
    marginLeft: isMobile ? "0px" : `${sidebarWidth}px`,
    width: isMobile ? "100%" : `calc(100% - ${sidebarWidth}px)`,
    padding: isMobile ? "10px" : "20px",
    boxSizing: "border-box",
    transition: "all 0.3s ease-in-out",
  };

  return (
    <div className="container-fluid text-center mt-1 position-relative main-content" style={{ paddingTop: "80px", overflow: "auto" }}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        {/* Left Section - Color legends */}
        <div style={calendarContainerStyle}>
          <div className="d-flex align-items-center gap-2">
            <Legend color="#FFCDD2" label="Holiday" />
            <Legend color="#FFE0B2" label="Training" />
            <Legend color="#6A1B9A" label="Birthday" />
            <Legend color="#BBDEFB" label="Event" />
          </div>
          <div className="d-flex align-items-center gap-2"></div>
          <div className="d-flex align-items-center gap-2"></div>
        </div>
        {canAdd && (
          <Button
            type="primary"
            size={isMobile ? "small" : "middle"}
            onClick={() => setShowForm(true)}
            icon={<PlusCircleOutlined />}
          >
            {!isMobile && "Add Event"}
          </Button>
        )}
      </div>
      {/* Calendar component */}
      <div style={calendarContainerStyle}>
        <Calendar showForms={showForm} setShowForms={setShowForm} />
      </div>
    </div>
  );
}

export default CustomCalendar;
